import { createElementBlock as t, openBlock as o, createElementVNode as r } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
};
function n(a, e) {
  return o(), t("svg", l, [...e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      d: "m27.708 16.707-9 9a1 1 0 1 1-1.415-1.415L24.586 17H5a1 1 0 1 1 0-2h19.586l-7.293-7.293a1 1 0 0 1 1.415-1.415l9 9a1 1 0 0 1 0 1.415"
    }, null, -1)
  ])]);
}
const i = { render: n };
export {
  i as default,
  n as render
};
